import Profile from './Profile'

export {
  Profile
}


// WEBPACK FOOTER //
// ./src/screens/Profile/index.js